<template>
    <div class="lds-dual-ring"></div>
</template>

<style lang="scss" scoped>
    .lds-dual-ring {
        display: inline-block;
        width: 30px;
        height: 30px;
    }
    .lds-dual-ring:after {
        content: ' ';
        display: block;
        width: 30px;
        height: 30px;
        margin: 8px;
        border-radius: 50%;
        border: 4px solid #fff;
        border-color: $red transparent $red transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
